/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl-next';

import { cssMap, jsx } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { RobotErrorImage } from '@atlassian/teams-common/assets';
import { token } from '@atlaskit/tokens';

import { messages } from '../i18n';

const styles = cssMap({
	wrapper: {
		paddingBlock: token('space.600', '48px'),
		paddingInline: token('space.600', '48px'),
	},
	contentWrapper: {
		textAlign: 'center',
	},
	imageWrapper: {
		height: '200px',
		marginBottom: token('space.400', '32px'),
	},
	headingWrapper: {
		maxWidth: '240px',
		marginBottom: token('space.300', '24px'),
	},
	messageWrapper: {
		maxWidth: '240px',
	},
});

export const ErrorScreen = () => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.wrapper}>
			<Stack alignBlock="center" alignInline="center" xcss={styles.contentWrapper}>
				<Inline xcss={styles.imageWrapper}>
					<img
						width="100%"
						height="100%"
						src={RobotErrorImage}
						alt={formatMessage(messages.errorImageAltText)}
					/>
				</Inline>
				<Inline xcss={styles.headingWrapper}>
					<Heading as="h3" size="medium">
						{formatMessage(messages.errorHeading)}
					</Heading>
				</Inline>
				<Inline xcss={styles.messageWrapper}>
					<Text as="p">{formatMessage(messages.errorText)}</Text>
				</Inline>
			</Stack>
		</Box>
	);
};

export default ErrorScreen;
